import { PopoverBody, PopoverHeader, UncontrolledPopover } from "reactstrap";
import helpMessages from "./helpMessages";
import HelpLink from "./HelpLink";

function HelpTip({ id }) {
    const data = helpMessages(id);
    if (!data) return null;
    const title = data.title;
    const message = data.message;
    const url = data.url;
    return (
        <div
            className="help-info-rs-popover"
            >
            <button
                type="button"
                id={id}
            >
                <i
                    className="info bi bi-question-circle-fill"
                ></i>
            </button>
                <UncontrolledPopover
                    flip
                    target={id}
                    trigger="legacy"
                >
                    {title &&
                        <PopoverHeader>
                            {title}
                        </PopoverHeader>
                    }
                    {message &&
                        <PopoverBody>
                            {message}
                        </PopoverBody>
                    }
                    {url &&
                        <PopoverBody className="support-url">
                            <HelpLink className="support-link" url={url} text={["Learn more ",  <i className="bi bi-caret-right-fill"></i>]} />
                        </PopoverBody>
                    }
                </UncontrolledPopover>
        </div>
    );    
}

export default HelpTip;
